// client/src/routes/app/reports/$reportCode.tsx — SCR-REPT-002 „Vizualizare raport" · REPORT-003
// (04 §7, §8.14, §9.2.3).
//
// The route owns the URL state and nothing else: `validateSearch` runs §9.2.3's schema and the
// screen reads it back typed, so a filtered report is shareable, survives a refresh, and Back is
// a filter-undo. That is also what makes 05 REPORT-003's „exports carry the same filters as the
// preview" structural — both halves read the same params.
//
// `Reports.Read` is the gate, which is the code the CATALOGUE and the eight economic and
// operational payload routes mount. The two fiscal reports mount `Fiscal.Read` on their payloads
// instead (D-1443), and `ReportViewer` renders SCR-SYS-403 for those alone rather than the route
// refusing the other eight along with them.

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { ReportViewer } from '@/features/reports/ReportViewer';
import { reportSearchSchema, type ReportSearch } from '@/features/reports/search';

export const Route = createFileRoute('/app/reports/$reportCode')({
  validateSearch: reportSearchSchema,
  component: ReportViewerRoute,
});

function ReportViewerRoute() {
  const { reportCode } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Reports.Read">
      <ReportViewer
        reportCode={reportCode}
        search={search}
        onSearchChange={(next: (previous: ReportSearch) => ReportSearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
